import { spacing, media, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import { interativeMedium, interativeSmall } from "../../typography/elements.js";
import "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
const base = {
  ...interativeSmall,
  display: "inline-block",
  padding: `${spacing.xs} ${spacing.lg}`,
  position: "relative",
  textAlign: "left",
  maxWidth: "380px",
  "&:has(svg), &:has(img)": {
    paddingLeft: `${spacing["2xl"]}`
  }
};
const baseLarge = {
  ...base,
  ...interativeMedium,
  [`@media (${media.queries.tablet.min})`]: {
    ...interativeMedium,
    padding: `${spacing.sm} ${spacing.lg}`
  },
  "&:has(svg), &:has(img)": {
    paddingLeft: `${spacing["2xl"]}`,
    [`@media (${media.queries.tablet.min})`]: {
      paddingLeft: `57px`
    }
  }
};
const iconBase = {
  height: "14px",
  width: "14px",
  fill: color.red,
  transition: "fill 0.5s ease-in-out",
  zIndex: "99",
  position: "absolute",
  left: `calc(${spacing["md"]} + 4px)`,
  top: "50%",
  transform: "translateY(-50%)"
};
const iconBaseLarge = {
  ...iconBase,
  left: `calc(${spacing["md"]} + 4px)`,
  [`@media (${media.queries.tablet.min})`]: {
    height: "17px",
    width: "17px",
    left: `34px`
  }
};
export {
  base,
  baseLarge,
  iconBase,
  iconBaseLarge
};
//# sourceMappingURL=_base.js.map
